import { createContext } from "react";

export type OperationalModulePickerContextValue = {
  openPicker: (moduleKey: string) => void;
  closePicker: () => void;
};

export const OperationalModulePickerContext =
  createContext<OperationalModulePickerContextValue | null>(null);
